import { assetLoader, audioPlayer } from "../PhaserExtension";
import { flump } from "../PhaserExtension";
import * as States from "./States";
import * as GameModel from "../models/GameModel";
import BaseState from "./BaseState";
import BallSwipeHandler from "../storyCircle/objects/BallSwipeHandler";
import FlumpObject from "../general/objects/FlumpObject";
import ChoiceIcon from "../storyCircle/objects/ChoiceIcon";
import MuppetCharacter from "../storyCircle/objects/MuppetCharacter";
import StoryBall from "../storyCircle/objects/StoryBall";
import Cutscene from "../storyCircle/objects/Cutscene";
import TimeoutGlow from "../storyCircle/objects/TImeoutGlow";

export default class StoryCircleState extends BaseState
{
    preload()
    {
        this.game.load.onFileComplete.add(this.onFileComplete, this);
        assetLoader.preloadAssetPacks(this.game, ["storyCircle"]);
        super.preload();
    }

    onFileComplete(progress, cacheKey, success, totalLoaded, totalFiles)
    {
        if(cacheKey == "storyCircleConfig")
        {
            this.config = this.game.cache.getJSON("storyCircleConfig");

            if(GameModel.data.storyKey == "")
            {
                this.currentSet = this.config.variables.storyChoice.images;
                this.storyKeys = this.config.variables.storyChoice.storyKeys;
            }
            else
            {
                this.currentSet = this.config.variables[GameModel.data.storyKey][GameModel.data.drawHistory.length - 1];
            }

            var imagePaths = this.currentSet.buttons;
            for(let i = 0; i < imagePaths.length; i++)
            {
                this.game.load.image("storyImage" + i, imagePaths[i]);
            }

            this.game.load.onFileComplete.remove(this.onFileComplete, this);
        }
    }

    create()
    {
        flump.addLibrary(this.game, "storyCircleFlump", "assets/storyCircle/flump/");
        audioPlayer.setupChannels(this.config.sounds.channels);
        audioPlayer.play(this.game, this.config.sounds.music);
        GameModel.data.currentStateName = "Classroom scene";
        this.setupComponents();
        super.create();
    }

    setupComponents()
    {
        this.background = new Phaser.Sprite(this.game, 0, 0, "sc_background");
        this.backgroundLayer.add(this.background);
        this.background.name = "background";
        this.player = new FlumpObject(this.game, this.config.assets.playerSolo, "storyCircleFlump");
        this.foregroundLayer.add(this.player);

        this.ball = new StoryBall(this.game, this.config.assets.ball, "storyCircleFlump");
        this.maingroundLayer.add(this.ball);
        this.ball.name = "Ball";

        // Add muppets
        this.muppets = [];
        this.timeoutGlows = [];
        for(var i = 0; i < 3; i++)
        {
            let conf = this.config.assets.muppets[i];
            let muppet = new MuppetCharacter(this.game, conf, "storyCircleFlump", i);
            muppet.name = "Muppet";

            if(i == GameModel.data.lastMuppet)
            {
                this.ball.position.setTo(muppet.x, muppet.y);
                this.ball.scale.setTo(this.ball.farScale.x, this.ball.farScale.y);
                this.ball.visible = false;
                muppet.loop(muppet.keys.idleWithBall);
            }

            let timeout = new TimeoutGlow(this.game, this.config.assets.timeoutGlow, "storyCircleFlump");
            timeout.name = "Timeout Glow";
            this.backgroundLayer.add(timeout);
            timeout.x = muppet.x;
            timeout.y = muppet.y;
            timeout.visible = false;
            this.timeoutGlows.push(timeout);

            this.muppets.push(muppet);
            this.maingroundLayer.add(muppet);
            this.ball.moveUp(); // Keep it above the muppets
        }

        this.starOverlay = new FlumpObject(this.game, this.config.assets.starOverlay, "storyCircleFlump");
        this.maingroundLayer.add(this.starOverlay);
        this.starOverlay.visible = false;

        this.choices = [];
        let conf = this.config.assets.choicePanels;
        for(var i = 0; i < this.currentSet.buttons.length; i++)
        {
            let choice = new ChoiceIcon(this.game, conf[i], "storyCircleFlump", i);
            choice.name = "Choice";
            this.maingroundLayer.add(choice);
            this.choices.push(choice);

            if(GameModel.data.turn == "")
            {
                choice.position.setTo(conf[i].storyPosition.x, conf[i].storyPosition.y);
            }
        }

        if(GameModel.data.turn == "")
        {
            this.cutscene = new Cutscene(this.game, this.config.assets.cutscene);
            this.cutscene.name = "Cutscene";
            this.maingroundLayer.add(this.cutscene);
            this.cutscene.setupCutscene();
            this.player.loop(this.player.keys.idle);
        }
        else if(GameModel.data.turn == "Player")
        {
            this.player.loop(this.player.keys.holdBall);
        }

        this.timeoutCount = 0;
        this.timeoutFiredTime = 0;
    }

    onTransitionInComplete()
    {
        super.onTransitionInComplete();

        if(GameModel.data.turn == "")
        {
            // This is the first time entering this scene.
            this.onFirstPlay();
            GameModel.data.currentStateName = "Intro screen";
        }
        else if(GameModel.data.turn == "Muppet")
        {
            this.onMuppetTurn();
        }
        else // Player turn
        {
            this.onPlayerTurn();
        }

        GameModel.data.groverTransition = 1;
    }

    onFirstPlay()
    {
        this.cutscene.playCutscene(this.muppets, this.debugLayer, this.ball, this);
        this.cutscene.onCutsceneComplete.addOnce(this.onPlayerReceiveComplete, this);
    }

    onPlayerTurn()
    {
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // IF YOU UPDATE THIS ALSO UPDATE THE 2P VERSION
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        this.swipeHandler = new BallSwipeHandler(this.game, this.player, this.muppets);
        this.swipeHandler.name = "swipe";
        this.swipeHandler.inputEnabled = true;
        this.swipeHandler.onSwipeCompleted.addOnce(this.onMuppetReceivedBall, this);
        this.foregroundLayer.add(this.swipeHandler);

        for(let i = 0; i < this.muppets.length; i++)
        {
            this.muppets[i].inputEnabled = true;
            this.muppets[i].input.useHandCursor = true;
            this.muppets[i].events.onInputUp.addOnce(this.onMuppetReceivedBall.bind(this, this.muppets[i].id));
        }

        audioPlayer.play(this.game, this.config.sounds.pass);
        this.passTimeout = this.game.time.create(false);
        this.passTimeout.loop(Phaser.Timer.SECOND * 12, this.onPassTimeout, this);
        this.passTimeout.start();
    }

    onPassTimeout()
    {
        if(this.timeoutCount == 0)
        {
            this.timeoutFiredTime = Date.now();
        }
        this.timeoutCount += 1;

        for(let i = 0; i < this.timeoutGlows.length; i++)
        {
            this.timeoutGlows[i].show();
        }

        audioPlayer.play(this.game, Phaser.ArrayUtils.getRandomItem(this.config.sounds.passTimeoutArray));
        GameModel.sendEvent("TimeoutPlay", "Classroom scene_Number_" + GameModel.fixNumber(this.timeoutCount));
    }

    onMuppetTurn()
    {
        let muppet = this.muppets[GameModel.data.lastMuppet];
        muppet.passBall(this.onMuppetPassedBall, this);
    }

    onMuppetPassedBall()
    {
        this.ball.tweenTo(this.config.assets.ball.transform.position);
        this.ball.onTweenComplete.addOnce(this.onPlayerReceivedBall, this);
    }

    onPlayerReceivedBall()
    {
        this.player.loop(this.player.keys.holdBall);
        this.player.playOnce(this.player.keys.receive, true);
        this.player.onComplete.addOnce(this.onPlayerReceiveComplete, this);
    }

    onPlayerReceiveComplete()
    {
        GameModel.data.currentStateName = "Classroom scene";
        this.player.loop(this.player.keys.revealIdle);
        this.player.playOnce(this.player.keys.revealStart, true);
        this.player.onComplete.addOnce(this.onRevealAnimationComplete, this);

        audioPlayer.play(this.game, this.config.sounds.starSFX);

        GameModel.data.turn = "Player";
        GameModel.data.lastMuppet = -1;
    }

    onRevealAnimationComplete()
    {
        let starAnim = new FlumpObject(this.game, this.config.assets.starAnimation, "storyCircleFlump");
        starAnim.playOnce(starAnim.keys.idle, false, true);
        starAnim.name = "star";
        starAnim.onComplete.addOnce(starAnim.destroy, starAnim);
        this.foregroundLayer.add(starAnim);

        this.starOverlay.visible = true;
        this.starOverlay.loop(this.starOverlay.keys.idle);
        this.starOverlay.playOnce(this.starOverlay.keys.enter);

        for(let i = 0; i < this.choices.length; i++)
        {
            this.game.time.events.add(
                this.choices[i].config.appearTiming,
                this.choices[i].reveal,
                this.choices[i]
            );
        }
        this.choices[this.choices.length - 1].onComplete.addOnce(this.onAllChoicesVisible, this);
    }

    onAllChoicesVisible()
    {
        if(GameModel.data.turn == "Muppet")
        {
            this.muppets[GameModel.data.lastMuppet].makeChoice(this.onStoryChoice, this);
        }
        else
        {
            this.player.playOnce(this.player.keys.revealEnd, true, true);
            this.player.onComplete.addOnce(this.player.destroy, this.player);

            if(!this.cutscene || (this.cutscene && this.cutscene.skipped))
            {
                if(GameModel.data.drawHistory.length === 0)
                {
                    audioPlayer.play(this.game, this.config.sounds.firstChoice, this.enableChoices, this);
                }
                else if(GameModel.data.drawHistory.length === GameModel.data.maxImages - 1)
                {
                    audioPlayer.play(this.game, this.config.sounds.finalPlayerTurn, this.enableChoices, this);
                }
                else
                {
                    audioPlayer.play(this.game, this.config.sounds.playerTurn, this.enableChoices, this);
                }
            }
            else
            {
                this.enableChoices();
            }
        }
    }

    enableChoices()
    {
        for(let i = 0; i < this.choices.length; i++)
        {
            this.choices[i].onSelected.add(this.onPlayerStoryChoice, this);
            this.choices[i].enable();
        }

        this.choiceTimeout = this.game.time.create(false);
        this.choiceTimeout.loop(Phaser.Timer.SECOND * 12, this.onChoiceTimeout, this);
        this.choiceTimeout.start();
    }

    onChoiceTimeout()
    {
        if(this.timeoutCount == 0)
        {
            this.timeoutFiredTime = Date.now();
        }
        this.timeoutCount += 1;
        audioPlayer.play(this.game, this.config.sounds.choiceTimeout);
        GameModel.sendEvent("TimeoutPlay", "Classroom scene_Number_" + GameModel.fixNumber(this.timeoutCount));
    }

    onMuppetReceivedBall(index)
    {
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // IF YOU UPDATE THIS ALSO UPDATE THE 2P VERSION
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        this.passTimeout.destroy();
        delete this.passTimeout;
        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "Classroom scene", Date.now() - this.timeoutFiredTime);
        }

        this.swipeHandler.onSwipeCompleted.removeAll();
        this.swipeHandler.inputEnabled = false;
        GameModel.data.lastMuppet = index;

        for(let i = 0; i < this.muppets.length; i++)
        {
            this.muppets[i].inputEnabled = false;
            this.muppets[i].events.onInputUp.removeAll();
        }

        this.player.loop(this.player.keys.idle);
        this.player.playOnce(this.player.keys.pass, true);

        this.player.onComplete.addOnce(function(){
            this.ball.tweenTo(this.config.assets.muppets[index].receivePosition);
            this.ball.onTweenComplete.addOnce(this.onBallTweenComplete, this);
        }, this);
    }

    onBallTweenComplete()
    {
        // Muppet receives ball, then the choices are displayed
        GameModel.data.turn = "Muppet";
        this.ball.visible = false;
        let muppet = this.muppets[GameModel.data.lastMuppet];
        muppet.receiveBall(this.onStoryChoice.bind(this, muppet.id), this);
    }

    onPlayerStoryChoice(id)
    {
        // Stop the timeout.
        this.choiceTimeout.destroy();
        delete this.choiceTimeout;

        audioPlayer.stopChannel("VO");

        this.choices[id].playSelected();

        for(let i = 0; i < this.choices.length; i++)
        {
            this.choices[i].disable();
            this.choices[i] = null;
        }

        audioPlayer.play(this.game, this.config.sounds.choiceSFX);

        if(GameModel.data.storyKey == "")
        {
            audioPlayer.play(this.game, this.config.sounds.firstSelection[id], this.onStoryChoice.bind(this, id));
        }
        else
        {
            audioPlayer.play(this.game, this.config.sounds.panelReaction, this.onStoryChoice.bind(this, id));
        }

        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "Classroom scene", Date.now() - this.timeoutFiredTime);
        }
    }

    onStoryChoice(id)
    {
        if(GameModel.data.storyKey == "")
        {
            GameModel.data.storyKey = this.storyKeys[id];
        }

        GameModel.data.storyImage = this.currentSet.coloringImages[id];
        GameModel.data.drawHistory.push(this.currentSet.coloringImages[id]);

        let debugSkip = this.game.net.getQueryString("skipStory");
        if(typeof(debugSkip) === "string")
        {
            debugSkip = +debugSkip;
            if(debugSkip < 0 || debugSkip > 3) debugSkip = 1;

            GameModel.data.drawHistory.push(this.config.variables[GameModel.data.storyKey][0].coloringImages[debugSkip]);
            GameModel.data.drawHistory.push(this.config.variables[GameModel.data.storyKey][1].coloringImages[debugSkip]);
            GameModel.data.drawHistory.push(this.config.variables[GameModel.data.storyKey][2].coloringImages[debugSkip]);
            GameModel.data.drawHistory.push(this.config.variables[GameModel.data.storyKey][3].coloringImages[debugSkip]);
            this.skipStory = true;
        }

        this.transistionOut();
    }

    onTransitionOutComplete()
    {
        if(this.skipStory)
        {
            var nextState = this.game.net.getQueryString("skipTo");
            if(typeof(nextState) != "string") nextState = States.CONGRATULATIONS;
        }
        else
        {
            var nextState = States.COLORING;
        }

        this.game.state.start(nextState);
        // this.game.state.start(States.POSTGAME);
        // this.game.state.start(States.RECAP);
    }

    shutdown()
    {
        for(let i = 0; i < this.currentSet.buttons.length; i++)
        {
            this.game.cache.removeImage("storyImage" + i);
        }

        if(this.cutscene)
        {
            this.cutscene.destroy();
            this.cutscene = null;
        }

        flump.removeLibrary("storyCircleFlump");
        assetLoader.unloadAssetPacks(this.game, ["storyCircle"]);
        audioPlayer.cleanupChannels(this.config.sounds.channels);
        delete this.muppets;
        delete this.timeoutGlows;
        delete this.player;
        delete this.starOverlay;
        delete this.ball;
        delete this.currentSet;
        delete this.swipeHandler;
        super.shutdown();
    }
}
